import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { FieldProps } from 'formik';
import { withFormLabel } from './withFormLabel';

type Props = FieldProps &
  Omit<TextFieldProps, 'name' | 'value' | 'error'> & {
    error?: boolean;
    min?: number;
    max?: number;
  };

export const Input = withFormLabel(
  ({
    disabled,
    multiline,
    field,
    min,
    max,
    error = false,
    type,
    ...props
  }: Props): JSX.Element => (
    <TextField
      multiline={multiline}
      disabled={disabled}
      error={error}
      size="small"
      variant="outlined"
      inputProps={{
        min,
        max,
      }}
      type={type}
      {...field}
      {...props}
    />
  ),
);
